export const toPriceNumber = (rawPrice: string | number): number => {
  const numberPrice = Number(rawPrice);

  if (isNaN(numberPrice)) {
    return null;
  }

  return Number(numberPrice.toFixed(2));
};
